import { Stack} from '@mui/material';
import './Term.scss';
import { TermConfig } from '../models/models';

export const Term = ({ term, definition, img_url, img_description}: TermConfig) => {
  return (
    <Stack className={'Term ' + term[0].toUpperCase()}>
        <div className='Label'>{term}</div>
        <Stack  className='Definition'>{definition}</Stack>
        {(img_description || img_url) &&
          <Stack  direction='row' className='Example'>
            {img_url && <img src={img_url} alt="" className='Image'/>}
            {img_description && <div  className='Description'>{img_description}</div>}
          </Stack>
        }
    </Stack>
  );
};